import { get, isObject } from "lodash";
import { getIcon } from "./icons";

import video from '../assets/image/video.png';
import audio from '../assets/image/audio.png';
import pdf from '../assets/image/pdf.png';
import archive from '../assets/image/zip.png';

export const downloadSrcGenerator = (props) => {
	const { name, content_type, media_type, audio_file, video_file, document_file } = props;
	if (content_type === "file" || ["video", "audio", "document", "presentation", "photo"].includes(media_type)) {
		const file = { video: video_file, audio: audio_file, document: document_file, presentation: document_file }[media_type];
		return file ? `${process.env.REACT_APP_CDN_URL}/uploads/${file.name || name}` : "";
	}
	return "";
};

export const generateMediaUrl = (src, size) => {
	//Check if source is object
	if (isObject(src)) {
		let image_url = src;
		const { name, extension, updated_at } = src;
		const w = get(size.split('x'), "[0]", 0);
		const h = get(size.split('x'), "[1]", 0);
		if (extension === "jpg" || extension === "jpeg" || extension === "png") {
			image_url = `/image/${w}x${h}/${name}`;
		}
		else {
			image_url = `/uploads/${name}`;
		}
		if (updated_at) {
			image_url = image_url + "?v=" + updated_at;
		}
		return process.env.REACT_APP_CDN_URL + image_url;
	}
	return src;
}

export const downloadTxtFile = (name, text) => {
	const getText = () => {
		var divContainer = document.createElement("div");
		divContainer.innerHTML = text.replace(/<br\s*\/?>/gi, ' ');
		return divContainer.textContent || divContainer.innerText || "";
	}

	const element = document.createElement("a");
	const file = new Blob([`${getText()}`], {
		type: "text/plain"
	});
	element.href = URL.createObjectURL(file);
	element.download = `${name}.txt`;
	document.body.appendChild(element);
	element.click();
};

export const isSaved = (articleId = "", savedList = []) => {
	if (articleId !== "" && savedList.length > 0) {
		return savedList.some(article_id => article_id === articleId)
	}
	return false;
}

export function MediaIcon({ type }) {
	const mediaTypeToIcon = {
		web: "Web",
		video: "Video",
        audio: "Speaker",
        podcast: "Podcast",
        document: "Document",
		presentation: "Document",
		photo: "Photo"
    };

    const iconName = mediaTypeToIcon[type];
    return iconName ? <i className={getIcon(iconName)}></i> : null;
};

export const mediaFormats = (type) => {
    switch (type) {
        case "image":
            return ['jpeg', 'jpg', 'svg', 'png', 'webp']
        case "video":
            return ['mp4', 'mov', 'wmv', 'mkv', 'webm', 'avi']
        case "audio":
            return ['mp3', 'm4a', 'wav', 'aac']
        case "document":
            return ["pdf"]
        case "csv":
            return ["csv"]
        default:
            return []
    }
}

export const imageFileExtensions = () => {
    return ['jpg', 'jpeg', 'png', 'svg'];
}

export const generateUrl = (data, size = "uploads") => {
	const { type, name,extension } = data;
	let url = '';
	if (type === 'video') {
		url = video;
	} else if (type === 'audio') {
		url = audio;
	} else if (['pdf', 'word', 'excel', 'powerpoint', 'code', 'design', 'font'].includes(type)) {
		url = pdf;
	}else if (type === 'archive'){
		url = archive;
	} else {
		size = (size !== "uploads" && extension !== "svg") ? `image/${size}` : "uploads";
		url = `${process.env.REACT_APP_CDN_URL}/${size}/${name}`;
	}
	return url;
}